import styled from "styled-components";

interface IContainer {
  height?: string;
  haveBalance?: any;
}
export const Container = styled.div<IContainer>`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  height: ${(props) => (props.height ? props.height : "auto")};
  padding: 4rem 2.5rem;
  width: 42.4rem;
  .title {
    color: #2e353d;
    font-family: "Montserrat";
    font-size: 2rem;
    font-style: normal;
    font-weight: 800;
    line-height: 2.4rem;
  }
  .subtitle {
    color: rgba(8, 8, 43, 0.55);
    font-family: "Montserrat";
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 500;
    line-height: 2.4rem;
    text-align: center;
  }
  .container-comment {
    display: flex;
    flex-direction: column;
    margin-top: 3.9rem;
    .label-comment {
      color: rgba(46, 53, 61, 0.3);
      font-family: "Montserrat";
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.7rem;
    }
    p {
      color: #2e353d;
      font-family: "Montserrat";
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 500;
      height: 10rem;
      line-height: 2rem;
      margin-top: 0.8rem;
      overflow-wrap: break-word;
      width: 37.5rem;
    }
  }
`;
